import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoBlock } from '../../../../../../components'
import {
  Container,
  TopInfoWrapper
} from './style'
import {timeConverterMMDDYYHHMM} from '../../../../../../utils/dates'

const Subnet:FC<any> = ({user}) => {
  const [t] = useTranslation()
  const specifications = [
    {
      title:t("FIRST_NAME"),
      id:'1',
      value:user.first_name
    },
    {
      title:t("LAST_NAME"),
      id:'2',
      value:user.last_name
    },
    {
      title:t("EMAIL"),
      id:'3',
      value:user.email
    },
    {
      title:t("EXTERNAL_BILLING_ID"),
      id:'4',
      value:user.external_billing_id || '-'
    },
    {
      title:t("EXTERNAL_AUTH_ID"),
      id:'4a',
      value:user.external_auth_id || '-'
    },
    {
      title:t("ID"),
      id:'5',
      value:user.id
    },
    {
      title:t("LAST_LOGIN"),
      id:'6',
      value: timeConverterMMDDYYHHMM(user.last_login)
    },
    {
      title:t("DATE_JOINED"),
      id:'7',
      value:timeConverterMMDDYYHHMM(user.date_joined)
    },
    {
      title:t("IS_STAFF"),
      id:'8',
      value: user.is_staff ? t("YES") : t("NO")
    },
    {
      title:t("IS_SUPERUSER"),
      id:'9',
      value: user.is_superuser ? t("YES") : t("NO")
    },
  ]
  return(
    <Container>
      <TopInfoWrapper>
        <InfoBlock
          data={specifications}
          customStyles={{marginTop:'10px', width:"545px", flex:'auto 1'}}
        />
      </TopInfoWrapper>
    </Container>
  )
}
export default Subnet
